import React from "react";
import PropTypes from "prop-types";
import FormHOC from "./FormHOC";

function TextField({ placeholder, type, label, value, onChangeText }) {
  return (
    <input
      className="px-5 py-1 flex-1 shadow border text-right rounded-lg"
      type={type}
      name=""
      // id={}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChangeText(e.target.value)}
    />
  );
}

export default FormHOC(TextField);
